'use strict';

var _ = require('lodash');
var UserFbcExclusionRulesService = function UserFbcExclusionRulesService(restangular, $q, $http) {
  var updateBulkExclusionRulesService = restangular.service('external').one('priceFBCExclusions');
  function deleteFromServer(payloads) {
    return _.map(payloads, function (payload) {
      return $http({
        method: 'DELETE',
        url: '/api/external/priceFBCExclusion',
        data: payload,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      });
    });
  }
  function remove(rows) {
    var payloads = buildRemovePayloads(rows);
    return $q.all(deleteFromServer(payloads));
  }
  function saveToServer(payloads) {
    var payload = {
      priceExclusions: payloads
    };
    return updateBulkExclusionRulesService.customPUT(payload);
  }
  function getEditedRows(rows) {
    return _.filter(rows, function (row) {
      var edited = false;
      _.forOwn(row._old, function (value) {
        if (value) {
          edited = true;
        }
      });
      return edited;
    });
  }
  function removeEditedRows(rows) {
    var toDelete = _.cloneDeep(getEditedRows(rows));
    _.each(toDelete, function (row) {
      _.forOwn(row._old, function (value, key) {
        row[key] = value;
      });
    });
    return remove(toDelete);
  }
  function savePayload(rows) {
    var payloads = buildSavePayloads(rows);
    return saveToServer(payloads);
  }
  function save(rows) {
    return removeEditedRows(rows).then(function () {
      return savePayload(rows);
    });
  }
  function buildRemovePayloads(rows) {
    return _.reduce(rows, function (result, row) {
      result.push(buildPayLoadForRemoval(row));
      return result;
    }, []);
  }
  function buildPayLoadForRemoval(row) {
    return {
      origin: allToAsterisk(row.originAirport),
      destination: allToAsterisk(row.destinationAirport),
      fareClass: allToAsterisk(row.fareClass),
      fbcPattern: row.fbcPattern
    };
  }
  function buildPayload(row) {
    return {
      origin: allToAsterisk(row.originAirport),
      destination: allToAsterisk(row.destinationAirport),
      fareClass: allToAsterisk(row.fareClass),
      fbcPattern: row.fbcPattern
    };
  }
  function allToAsterisk(value) {
    return value === 'All' ? '*' : value;
  }
  function buildSavePayloads(rows) {
    return _.reduce(rows, function (result, row) {
      result.push(buildPayload(row));
      return result;
    }, []);
  }
  return {
    save: save,
    remove: remove
  };
};
UserFbcExclusionRulesService.$inject = ['Restangular', '$q', '$http'];
module.exports = UserFbcExclusionRulesService;